import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { marked } from 'marked';
import SafeHtml from './SafeHtml';

function MarkdownRenderer({ options = {}, content }) {
  const [html, setHtml] = useState();

  useEffect(() => {
    const printError = (error) => {
      if (error) {
        setHtml('<p>{error.name}: {error.message}</p><p>{error.stack}</p>');
      } else {
        setHtml('<p>{error}</p>');
      }
    };

    try {
      marked.parse(content, options, (error, parsedResult) => {
        if (error) {
          printError(error);
        } else {
          setHtml(parsedResult);
        }
      });
    } catch (e) {
      printError(e);
    }
  }, [options, content, setHtml]);

  return <SafeHtml html={html} />;
}

MarkdownRenderer.propTypes = {
  options: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  content: PropTypes.string.isRequired,
};

MarkdownRenderer.defaultProps = {
  options: {},
};

export default MarkdownRenderer;
